export const maskBankAccountName = (name: string): string => {
  return (
    (name.length &&
      name
        .split(" ")
        .map((piece) =>
          piece
            .split("")
            .map((char, idx) => {
              let { length } = piece;
              return !idx || (length > 1 && idx === length - 1)
                ? char.toUpperCase()
                : "*";
            })
            .join("")
        )
        .join(" ")) ||
    ""
  );
};

export const maskBankAccountNumber = (
  num: string,
  last: number = 4
): string => {
  return (
    (num.length && "x".repeat(num.length - last) + "-" + num.substr(-last)) ||
    ""
  );
};
